import { useEffect, useRef, useState } from "react";
import Map from '@arcgis/core/Map'
import MapView from '@arcgis/core/views/MapView'
import Graphic from '@arcgis/core/Graphic'
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import ArgonBox from "components/ArgonBox";
import { Fab, Menu, MenuItem } from "@mui/material";
import { Layers } from "@mui/icons-material";
// import { loadModules } from 'esri-loader';

const markerSymbol = {
    type: "simple-marker",
    color: [226, 0, 40],  // Orange
    outline: {
        color: [255, 255, 255], // White
        width: 0.2
    },
    size: '7px'
};

const lineSymbol = {
    type: "simple-line",
    color: [226, 0, 0], // Orange
    width: 1
};

const generatePath = (params) => {
    let arrPath = params.split("\r\n")
    let output = [];
    arrPath.forEach(element => {
        let point = element.split("\t");
        let latLong = [parseFloat(point[1]), parseFloat(point[0])]
        output.push(latLong)
    });
    console.log(output);
    return output
}

const generateGraphic = (params) => {
    let output;
    if (params.geometry_type === 'point') {
        if (params.latitude !== '') {
            output = new Graphic({
                geometry: {
                    type: "point",
                    latitude: parseFloat(params.latitude),
                    longitude: parseFloat(params.longitude)
                },
                symbol: markerSymbol,
                attributes: params
            });

        }
    }
    else if (params.geometry_type === 'polyline') {
        output = new Graphic({
            geometry: {
                type: "polyline",
                paths: generatePath(params.path)
            },
            symbol: lineSymbol,
            attributes: params
        });
    }
    return output;
}

const generateCenter = (params) => {
    let output;
    if (params.geometry_type === 'point') {
        output = [parseFloat(params.longitude), parseFloat(params.latitude)]
    }
    else if (params.geometry_type === 'polyline') {
        let path = params.path
        let arrPath = path.split("\r\n")
        let firstPointString = arrPath[0]
        let pointArray = firstPointString.split("\t");
        let lat = parseFloat(pointArray[1])
        let long = parseFloat(pointArray[0])

        output = [parseFloat(lat), parseFloat(long)]
    }
    return output;
}

const MapSingle = ({ data }) => {
    const mapRef = useRef()

    const [basemap, setBasemap] = useState('streets-navigation-vector')

    useEffect(() => {
        const map = new Map({
            basemap: basemap,
            showAttribution: false
        });

        const view = new MapView({
            container: mapRef.current,
            map: map,
            zoom: 12,
            showAttribution: false,
            center: generateCenter(data) // longitude, latitude
        });

        // create empty FeatureLayer
        const layer = new GraphicsLayer({
            // create an instance of esri/layers/support/Field for each field object
            title: "National Monuments",
            fields: [
                {
                    name: 'id',
                    alias: 'ID',
                    type: 'oid'
                },
                {
                    name: "geometry_type",
                    alias: "Name",
                    type: "string"
                },
                {
                    name: 'kode_rekening_akun',
                    alias: 'KD Rek',
                    type: 'string'
                },
            ],
            objectIdField: "ObjectID",
            geometryType: "point",
            spatialReference: { wkid: 4326 },
            source: [], // adding an empty feature collection
            popupTemplate: {
                title: "{nama_komponen}",
                content: "{kode_rekening_akun} {uraian_rekening_akun}"
            }
        });

        let graphic = generateGraphic(data);

        map.add(layer);
        layer.add(graphic)
    }, [basemap, data])

    const mapStyle = {
        width: '100%',
        height: '100%',
        position: 'absolute',
        right: 0,
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        setAnchorEl(null);
        let value = event.target.getAttribute('value');
        value !== null && setBasemap(value)
    };

    return (
        <ArgonBox className="map-container" ref={mapRef} sx={mapStyle} >
            <Fab
                size="small"
                color="white"
                aria-label="add"
                sx={{
                    position: 'absolute',
                    left: '10px',
                    bottom: '10px'
                }}
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Layers />
            </Fab>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <MenuItem key='0' value="streets-navigation-vector" onClick={handleClose}>Default</MenuItem>
                <MenuItem key='1' value="satellite" onClick={handleClose}>Satellite</MenuItem>
                <MenuItem key='2' value="dark-gray-vector" onClick={handleClose}>Dark</MenuItem>
                <MenuItem key='3' value="topo" onClick={handleClose}>Topografi</MenuItem>
                <MenuItem key='4' value="streets" onClick={handleClose}>Street</MenuItem>
            </Menu>
        </ArgonBox>
    );
};

export default MapSingle;